import Swiper from 'swiper';
import {Navigation, Scrollbar} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

window.addEventListener('DOMContentLoaded', (event) => {
    const swiperDgacf = new Swiper('.swiperDgacf', {
        modules: [Navigation, Scrollbar],
        direction: 'horizontal',
        breakpoints: {
            480: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },

        navigation: {
            nextEl: '.swiper-dgacf-button-next',
            prevEl: '.swiper-dgacf-button-prev',
        },

        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        on: {
            init: function(thisSwiper) {
                const element = document.querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0];
                if (element) {
                    if (window.innerWidth >= 1025) {
                        if (element.classList.contains('starts-begining')) {
                            document
                                .querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0]
                                .style.paddingLeft = '0px';
                        } else {
                            const headerWeb = document.querySelector('header .uagb-container-inner-blocks-wrap');
                            const positionLeft = headerWeb.getBoundingClientRect().x;
                            document
                                .querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0]
                                .style.paddingLeft = parseInt(positionLeft) + 'px';
                        }
                    }

                    [...document.querySelectorAll('.swiper[data-id="' + thisSwiper.el.dataset.id + '"] .swiper-slide')]
                        .forEach((element) => {
                            element.style.minWidth = element.style.width;
                        });
                }
            },
            afterInit: function(thisSwiper) {
                thisSwiper.params.breakpoints[480].slidesPerView = thisSwiper.el.dataset.mobile;
                thisSwiper.params.breakpoints[768].slidesPerView = thisSwiper.el.dataset.tablet;
                thisSwiper.params.breakpoints[1024].slidesPerView = thisSwiper.el.dataset.desktop;
                thisSwiper.currentBreakpoint = false;
                thisSwiper.update();
            },
            slideChange: function(thisSwiper) {
                const indexCurrentSlide = thisSwiper.realIndex;
                if (indexCurrentSlide > 0) {
                    document
                        .querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0]
                        .style.paddingLeft = '0px';
                    document
                        .querySelectorAll(
                            '[data-id="' + thisSwiper.el.dataset.id + '"] .slider-dynamic-gallery__footer'
                        )[0].style.marginLeft = 'auto';
                    document
                        .querySelectorAll(
                            '[data-id="' + thisSwiper.el.dataset.id + '"] .slider-dynamic-gallery__footer'
                        )[0].style.marginRight = 'auto';
                } else {
                    const headerWeb = document.querySelector('header .uagb-container-inner-blocks-wrap');
                    const positionLeft = headerWeb.getBoundingClientRect().x;
                    document
                        .querySelectorAll('[data-id="' + thisSwiper.el.dataset.id + '"]')[0]
                        .style.paddingLeft = parseInt(positionLeft) + 'px';
                    document
                        .querySelectorAll(
                            '[data-id="' + thisSwiper.el.dataset.id + '"] .slider-dynamic-gallery__footer'
                        )[0].style.marginLeft = '0px';
                    document
                        .querySelectorAll(
                            '[data-id="' + thisSwiper.el.dataset.id + '"] .slider-dynamic-gallery__footer'
                        )[0].style.marginRight = '0px';
                }
            },
        },
    });

    const globalSwipersDgacf = document.querySelectorAll('.swiperDgacf');
    globalSwipersDgacf.forEach((currentSwiper) => {
        const element = document.querySelectorAll('[data-id="' + currentSwiper.dataset.id + '"]')[0];
        if (element) {
            if (window.innerWidth >= 1025) {
                if (element.classList.contains('starts-begining')) {
                    document
                        .querySelectorAll('[data-id="' + currentSwiper.dataset.id + '"]')[0]
                        .style.paddingLeft = '0px';
                } else {
                    const headerWeb = document.querySelector('header .uagb-container-inner-blocks-wrap');
                    const positionLeft = headerWeb.getBoundingClientRect().x;
                    document
                        .querySelectorAll('[data-id="' + currentSwiper.dataset.id + '"]')[0]
                        .style.paddingLeft = parseInt(positionLeft) + 'px';
                }
            }
        }
    });
});

window.onresize = (e) => {
    const elements = document.querySelectorAll('.swiperDgacf');
    if (elements) {
        if (window.innerWidth >= 1025) {
            elements.forEach((element) => {
                if (element.classList.contains('starts-begining')) {
                    document
                        .querySelectorAll('[data-id="' + element.dataset.id + '"]')[0]
                        .style.paddingLeft = '0px';
                } else {
                    const headerWeb = document.querySelector('header .uagb-container-inner-blocks-wrap');
                    const positionLeft = headerWeb.getBoundingClientRect().x;
                    document
                        .querySelectorAll('[data-id="' + element.dataset.id + '"]')[0]
                        .style.paddingLeft = parseInt(positionLeft) + 'px';
                }
            });
        }
    }
};
